import { namePicture } from "../lib/worldThumb.ts";

/** MC Planner's mark: a grass block seen from above-left, with the sun from the logo. Our own drawing. */
export function BrandMark({ size = 20, title }: { size?: number; title?: string }) {
  return (
    <svg className="brand-mark" width={size} height={size} viewBox="0 0 24 24" role={title ? "img" : undefined} aria-label={title} aria-hidden={title ? undefined : true}>
      <path d="M12 3.2 20.4 8 12 12.8 3.6 8Z" fill="#8fd96a" />
      <path d="M3.6 8 12 12.8v8L3.6 16Z" fill="#6fbf4a" />
      <path d="M20.4 8 12 12.8v8l8.4-4.8Z" fill="#4c8f30" />
      <circle cx="18.6" cy="4.4" r="2.1" fill="#e8b04a" />
    </svg>
  );
}

/**
 * A world without a picture of its own: a small pixel map made from its name (lib/worldThumb.ts), drawn with hard
 * edges like the game. The same name always gets the same map.
 */
export function WorldTile({ name, size = 22 }: { name: string; size?: number }) {
  return <img className="world-tile" src={namePicture(name)} alt="" aria-hidden="true" width={size} height={size} draggable={false} />;
}
